import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";

const Menu = function (props) {
  const activeStyle = { color: "#F15B2A" };
  const { isAuthenticated, logout } = props.auth;

  return (
    <div className="container px-0">
      <div className="row g-0">
        <div className="col-md-12 px-0">
          <nav className="navbar navbar-light navbar-expand-md px-0">
            <NavLink
              to="/"
              exact
              className="navbar-brand d-flex flex-column"
              style={{ fontWeight: 800, fontSize: "2.7rem", letterSpacing: "-0.5px", paddingLeft: 0, marginLeft: 0, lineHeight: 1 }}
            >
              <span>
                <span style={{ color: "#1e2d5f" }}>BOX</span><span style={{ color: "#e8192c" }}>HEAT</span>
              </span>
              {isAuthenticated() && (
                <span style={{ fontSize: "0.75rem", fontWeight: 400, letterSpacing: "0.05em", color: "#6c757d" }}>
                  Engineers Hub
                </span>
              )}
            </NavLink>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarMenu"
              aria-controls="navbarMenu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarMenu">
              <div className="navbar-nav me-auto mt-2 mt-md-0">
                <NavLink className="nav-link" style={{ fontSize: "1.1rem" }} to="/" exact activeStyle={activeStyle}>
                  Home
                </NavLink>
                <NavLink className="nav-link" style={{ fontSize: "1.1rem" }} to="/jobs" activeStyle={activeStyle}>
                  Jobs
                </NavLink>
                <NavLink className="nav-link" style={{ fontSize: "1.1rem" }} to="/engineer" activeStyle={activeStyle}>
                  My Details
                </NavLink>
              </div>
              {isAuthenticated() && (
                <button
                  className="btn btn-danger btn-lg mt-4 mt-md-0 ms-md-4"
                  onClick={logout}
                >
                  <FontAwesomeIcon icon={faSignOut} className="me-2" />
                  Sign Out
                </button>
              )}
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

Menu.propTypes = {
  auth: PropTypes.object,
};

export default Menu;
